import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, vModelText as _vModelText } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "clearfix top10"
};
const _hoisted_2 = { class: "clearfix" };
const _hoisted_3 = {
    key: 0,
    class: "input-group top_search"
};
const _hoisted_4 = { class: "input-group top_search" };
const _hoisted_5 = { class: "clearfix" };
const _hoisted_6 = { class: "clearfix" };
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("div", { class: "float-start" }, [
    /*#__PURE__*/ _createElementVNode("label", { class: "normal" }, "Period")
], -1 /* HOISTED */);
const _hoisted_8 = {
    key: 0,
    class: "float-end"
};
const _hoisted_9 = {
    key: 0,
    class: "btn-group pw100 bottom10"
};
const _hoisted_10 = {
    key: 1,
    class: "row left-10 right-10"
};
const _hoisted_11 = { class: "col-xs-12 col-sm-12 col-md-6" };
const _hoisted_12 = /*#__PURE__*/ _createElementVNode("div", { class: "input-group-append input-group-btn" }, [
    /*#__PURE__*/ _createElementVNode("button", {
        type: "button",
        class: "btn btn-default",
        "data-toggle": ""
    }, [
        /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-calendar" })
    ])
], -1 /* HOISTED */);
const _hoisted_13 = { class: "col-xs-12 col-sm-12 col-md-6" };
const _hoisted_14 = /*#__PURE__*/ _createElementVNode("div", { class: "input-group-append input-group-btn" }, [
    /*#__PURE__*/ _createElementVNode("button", {
        type: "button",
        class: "btn btn-default",
        "data-toggle": ""
    }, [
        /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-calendar" })
    ])
], -1 /* HOISTED */);
const _hoisted_15 = { class: "clearfix measurement-filter" };
const _hoisted_16 = /*#__PURE__*/ _createElementVNode("label", { class: "normal" }, "Measurement", -1 /* HOISTED */);
const _hoisted_17 = { class: "btn-group pw100" };
const _hoisted_18 = { class: "measurement-options bottom10" };
const _hoisted_19 = ["onClick"];
const _hoisted_20 = {
    key: 0,
    class: "clearfix"
};
const _hoisted_21 = { class: "d-flex justify-content-start mt-2" };
const _hoisted_22 = { class: "ms-2" };
const _hoisted_23 = /*#__PURE__*/ _createElementVNode("label", { class: "normal" }, "Select All by default", -1 /* HOISTED */);
const _hoisted_24 = { class: "clearfix" };
const _hoisted_25 = /*#__PURE__*/ _createElementVNode("label", { class: "normal text-muted mb-2 d-block" }, "Data Point Interval (days)", -1 /* HOISTED */);
const _hoisted_26 = { class: "d-flex flex-column align-items-start" };
const _hoisted_27 = { class: "snapshot-interval-slider" };
const _hoisted_28 = ["max"];
const _hoisted_29 = { class: "interval-labels" };
const _hoisted_30 = {
    class: "ms-2",
    style: { "min-height": "32px" }
};
const _hoisted_31 = /*#__PURE__*/ _createElementVNode("label", { class: "normal small text-muted mb-0" }, "Auto-suggest interval for optimal performance", -1 /* HOISTED */);
const _hoisted_32 = {
    class: /*#__PURE__*/ _normalizeClass(['component-tree-wrapper']),
    style: { "max-height": "350px", "height": "350px" }
};
const _hoisted_33 = { class: "component-tree component-tree-small" };
const _hoisted_34 = { class: "float-end float-start-sm" };
const _hoisted_35 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-times" }, null, -1 /* HOISTED */);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_multiselect = _resolveComponent("multiselect");
    const _component_b_button = _resolveComponent("b-button");
    const _component_flat_pickr = _resolveComponent("flat-pickr");
    const _component_b_input_group_append = _resolveComponent("b-input-group-append");
    const _component_b_input_group = _resolveComponent("b-input-group");
    const _component_b_form_input = _resolveComponent("b-form-input");
    const _component_b_form_checkbox = _resolveComponent("b-form-checkbox");
    const _component_ComponentTreeVue = _resolveComponent("ComponentTreeVue");
    const _component_b_container = _resolveComponent("b-container");
    const _component_b_modal = _resolveComponent("b-modal");
    const _directive_b_tooltip = _resolveDirective("b-tooltip");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        (_ctx.filtersReady)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    (_ctx.showCompanySelect)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                            _createVNode(_component_multiselect, {
                                modelValue: _ctx.selectedCompany,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.selectedCompany) = $event)),
                                options: _ctx.companies,
                                "track-by": "value",
                                label: "text",
                                showLabels: false,
                                placeholder: "Any company",
                                class: "multiselect-small",
                                "allow-empty": false
                            }, {
                                noResult: _withCtx(() => [
                                    _createTextVNode("\r\n\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t")
                                ]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["modelValue", "options"])
                        ]))
                        : _createCommentVNode("v-if", true),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_4, [
                        _createVNode(_component_multiselect, {
                            modelValue: _ctx.system,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.system) = $event)),
                            options: _ctx.visibleSystems,
                            "track-by": "systemId",
                            label: "displayName",
                            showLabels: false,
                            placeholder: _ctx.selectPlaceholderSystem,
                            class: _normalizeClass(['multiselect-small', _ctx.isSystemInvalid ? 'is-invalid' : ''])
                        }, {
                            noResult: _withCtx(() => [
                                _createTextVNode("\r\n\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t")
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["modelValue", "options", "placeholder", "class"])
                    ])
                ]),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                        _hoisted_7,
                        _createTextVNode(),
                        (_ctx.showDatePickers)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                _createElementVNode("a", {
                                    href: "#",
                                    onClick: _cache[2] || (_cache[2] =
                                        //@ts-ignore
                                        (...args) => (_ctx.resetDateFilterOption && _ctx.resetDateFilterOption(...args)))
                                }, "Reset dates")
                            ]))
                            : _createCommentVNode("v-if", true)
                    ]),
                    _createTextVNode(),
                    (!_ctx.showDatePickers)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dateFilterOptions, (item, idx) => {
                                return _withDirectives((_openBlock(), _createBlock(_component_b_button, {
                                    class: "pw100",
                                    key: idx,
                                    variant: _ctx.dateFilterOption == item ? 'primary' : 'outline-secondary',
                                    onClick: ($event) => (_ctx.setDateFilterOption(item)),
                                    title: _ctx.getPeriodTitle(item)
                                }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item), 1 /* TEXT */)
                                    ]),
                                    _: 2 /* DYNAMIC */
                                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["variant", "onClick", "title"])), [
                                    [
                                        _directive_b_tooltip,
                                        void 0,
                                        void 0,
                                        { hover: true }
                                    ]
                                ]);
                            }), 128 /* KEYED_FRAGMENT */))
                        ]))
                        : _createCommentVNode("v-if", true),
                    _createTextVNode(),
                    (_ctx.showDatePickers)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                            _createElementVNode("div", _hoisted_11, [
                                _createVNode(_component_b_input_group, {
                                    class: _normalizeClass(['top_search', _ctx.areDatesInvalid || _ctx.startDateInvalid ? 'is-invalid' : ''])
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_flat_pickr, {
                                            class: "form-control",
                                            modelValue: _ctx.query.startTime,
                                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.query.startTime) = $event)),
                                            config: _ctx.datePickerConfig,
                                            placeholder: "Select date"
                                        }, null, 8 /* PROPS */, ["modelValue", "config"]),
                                        _createTextVNode(),
                                        _createVNode(_component_b_input_group_append, null, {
                                            default: _withCtx(() => [
                                                _hoisted_12
                                            ]),
                                            _: 1 /* STABLE */
                                        })
                                    ]),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["class"])
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_13, [
                                _createVNode(_component_b_input_group, {
                                    class: _normalizeClass(['top_search', _ctx.areDatesInvalid || _ctx.endDateInvalid ? 'is-invalid' : ''])
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_flat_pickr, {
                                            class: "form-control",
                                            modelValue: _ctx.query.endTime,
                                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.query.endTime) = $event)),
                                            config: _ctx.datePickerConfig,
                                            placeholder: "Select date"
                                        }, null, 8 /* PROPS */, ["modelValue", "config"]),
                                        _createTextVNode(),
                                        _createVNode(_component_b_input_group_append, null, {
                                            default: _withCtx(() => [
                                                _hoisted_14
                                            ]),
                                            _: 1 /* STABLE */
                                        })
                                    ]),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["class"])
                            ])
                        ]))
                        : _createCommentVNode("v-if", true)
                ]),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_15, [
                    _hoisted_16,
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_17, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.measurementCategoriesVisible, (category, index) => {
                            return (_openBlock(), _createBlock(_component_b_button, {
                                class: "pw100 tabs",
                                key: category.measurementCategoryId,
                                variant: _ctx.measurementCategory.measurementCategoryName == category.measurementCategoryName ? 'primary' : 'outline-secondary',
                                onClick: ($event) => (_ctx.setMeasurementCategory(category))
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(category.measurementCategoryName), 1 /* TEXT */)
                                ]),
                                _: 2 /* DYNAMIC */
                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["variant", "onClick"]));
                        }), 128 /* KEYED_FRAGMENT */))
                    ]),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_18, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.measurementTypeVisible, (item, itemIdx) => {
                            return (_openBlock(), _createElementBlock("div", {
                                class: _normalizeClass(['measurement-option', _ctx.measurementType == item ? 'selected-option' : '']),
                                onClick: ($event) => (_ctx.setMeasurementType(item))
                            }, [
                                _createElementVNode("div", {
                                    class: _normalizeClass(['title', _ctx.measurementType == item ? 'white' : ''])
                                }, _toDisplayString(item.measurementTypeName), 3 /* TEXT, CLASS */)
                            ], 10 /* CLASS, PROPS */, _hoisted_19));
                        }), 256 /* UNKEYED_FRAGMENT */))
                    ])
                ]),
                _createTextVNode(),
                (_ctx.measurementTypeRequiresNode)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                        _createVNode(_component_b_input_group, {
                            class: _normalizeClass(['clearfix bottom0 popup-selection-control', _ctx.areNodesInvalid ? 'is-invalid' : '']),
                            title: _ctx.selectedLocationsTitle,
                            onClick: _cache[5] || (_cache[5] = ($event) => (_ctx.locationsModalVisible = true))
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_b_form_input, {
                                    placeholder: _ctx.selectedLocationsPlaceholder,
                                    value: _ctx.selectedLocationsText,
                                    readonly: ""
                                }, null, 8 /* PROPS */, ["placeholder", "value"]),
                                _createTextVNode(),
                                _createVNode(_component_b_input_group_append, null, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_b_button, {
                                            type: "button",
                                            variant: "outline-secondary"
                                        }, {
                                            default: _withCtx(() => [
                                                _createTextVNode("\r\n\t\t\t\t\t\t...\r\n\t\t\t\t\t")
                                            ]),
                                            _: 1 /* STABLE */
                                        })
                                    ]),
                                    _: 1 /* STABLE */
                                })
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["class", "title"]),
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_21, [
                            _createVNode(_component_b_button, {
                                class: "me-2",
                                variant: "primary",
                                onClick: _ctx.selectAllLocations
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode("Select All")
                                ]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["onClick"]),
                            _createTextVNode(),
                            _createVNode(_component_b_button, {
                                variant: "primary",
                                onClick: _ctx.unselectAllLocations
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode("Unselect All")
                                ]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["onClick"])
                        ]),
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_22, [
                            _withDirectives((_openBlock(), _createBlock(_component_b_form_checkbox, {
                                id: "displayValue",
                                modelValue: _ctx.selectAllByDefault,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.selectAllByDefault) = $event)),
                                switch: ""
                            }, {
                                default: _withCtx(() => [
                                    _hoisted_23
                                ]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["modelValue"])), [
                                [
                                    _directive_b_tooltip,
                                    void 0,
                                    void 0,
                                    {
                                        right: true,
                                        hover: true
                                    }
                                ]
                            ])
                        ])
                    ]))
                    : _createCommentVNode("v-if", true),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_24, [
                    _hoisted_25,
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("div", _hoisted_27, [
                            _withDirectives(_createElementVNode("input", {
                                type: "range",
                                class: "form-range",
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_ctx.snapshotDayIntervalIndex) = $event)),
                                min: "0",
                                max: _ctx.snapshotDayIntervals.length - 1,
                                step: "1"
                            }, null, 8 /* PROPS */, _hoisted_28), [
                                [
                                    _vModelText,
                                    _ctx.snapshotDayIntervalIndex,
                                    void 0,
                                    { number: true }
                                ]
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_29, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.snapshotDayIntervals, (interval, index) => {
                                    return (_openBlock(), _createElementBlock("span", {
                                        key: index,
                                        class: _normalizeClass({ 'active': _ctx.snapshotDayIntervalIndex === index, 'disabled': _ctx.isIntervalDisabled(index) })
                                    }, _toDisplayString(interval), 3 /* TEXT, CLASS */));
                                }), 128 /* KEYED_FRAGMENT */))
                            ])
                        ]),
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_30, [
                            _createVNode(_component_b_form_checkbox, {
                                modelValue: _ctx.autoSuggestInterval,
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_ctx.autoSuggestInterval) = $event)),
                                switch: ""
                            }, {
                                default: _withCtx(() => [
                                    _hoisted_31
                                ]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["modelValue"])
                        ])
                    ])
                ])
            ]))
            : _createCommentVNode("v-if", true),
        _createTextVNode(),
        _createCommentVNode(" Begin::Locations Modal "),
        _createTextVNode(),
        _createVNode(_component_b_modal, {
            modelValue: _ctx.locationsModalVisible,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((_ctx.locationsModalVisible) = $event)),
            id: _ctx.locationsModalId,
            "header-bg-variant": "normal",
            size: "md",
            static: true
        }, {
            title: _withCtx(() => [
                _createTextVNode("\r\n\t\t\tLocations\r\n\t\t")
            ]),
            footer: _withCtx(() => [
                _createElementVNode("div", _hoisted_34, [
                    _createVNode(_component_b_button, {
                        type: "button",
                        variant: "secondary",
                        onClick: _cache[10] || (_cache[10] = ($event) => (_ctx.locationsModalVisible = false))
                    }, {
                        default: _withCtx(() => [
                            _hoisted_35,
                            _createTextVNode(" Close\r\n\t\t\t\t")
                        ]),
                        _: 1 /* STABLE */
                    })
                ])
            ]),
            default: _withCtx(() => [
                _createTextVNode(),
                _createVNode(_component_b_container, { clearfix: "" }, {
                    default: _withCtx(() => [
                        (_openBlock(), _createElementBlock("div", {
                            class: "clearfix",
                            key: _ctx.componentTreeKey
                        }, [
                            _createElementVNode("div", _hoisted_32, [
                                _createElementVNode("ul", _hoisted_33, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleComponentTree, (child, index) => {
                                        return (_openBlock(), _createBlock(_component_ComponentTreeVue, {
                                            ref_for: true,
                                            ref: "componentTreeVueList",
                                            key: index,
                                            item: child,
                                            "parent-id": -1,
                                            "selected-nodes": _ctx.query.nodes,
                                            "onUpdate:selectedNodes": _cache[9] || (_cache[9] = ($event) => ((_ctx.query.nodes) = $event))
                                        }, null, 8 /* PROPS */, ["item", "selected-nodes"]));
                                    }), 128 /* KEYED_FRAGMENT */))
                                ])
                            ])
                        ]))
                    ]),
                    _: 1 /* STABLE */
                }),
                _createTextVNode()
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["modelValue", "id"]),
        _createTextVNode(),
        _createCommentVNode(" End::Locations Modal ")
    ], 64 /* STABLE_FRAGMENT */));
}
